import React from 'react'
import PropTypes from 'prop-types'
import useMobile from './mobile'

import Pagination from 'antd/lib/pagination'

import './DatatablePagination.scss'

export const DatatablePagination = ({
  total,
  page,
  perPage,
  data,
  onPageChange,
}) => {
  const isMobile = useMobile()
  const showing = data.length + (page - 1) * perPage

  return (
    <div className="x-datatable-pagination">
      {!isMobile && (
        <span className="datatable-pagination-info">
          <span>Showing</span>
          <strong>{showing}</strong>
          <span>of</span>
          <span>{total}</span>
        </span>
      )}

      <Pagination
        current={page}
        total={total}
        pageSize={perPage}
        showSizeChanger={false}
        onChange={(e) => onPageChange(e)}
      />
    </div>
  )
}

DatatablePagination.propTypes = {
  total: PropTypes.number,
  page: PropTypes.number,
  perPage: PropTypes.number,
  data: PropTypes.array,
  onPageChange: PropTypes.func,
}

DatatablePagination.defaultProps = {
  total: 0,
  page: 1,
  perPage: 10,
  data: [],
  onPageChange: () => {},
}

export default DatatablePagination
